import React from "react";
import _ from "lodash";
import Card from "react-bootstrap/Card";

export default class IndexTranscriptionQueue extends React.Component {
  componentDidUpdate(prevProps, _) {
    const { queue } = this.props;
    if (queue.length < 22 && prevProps.queue.length >= 22) {
      this.props.updateQueueThrottled();
    }
  }

  render() {
    const {
      currentlyEditing,
      currentContractor,
      queue,
      totalCount,
      claimingCall,
      claimCall,
    } = this.props;

    let card;
    if (currentlyEditing.length > 0) {
      card = (
        <Card body>
          <h1>You are still editing:</h1>
          <br />
          {currentlyEditing.map(c => {
            return (
              <div key={c.call_id}>
                <a href={"/transcriptions/" + c.call_id}>{c.call_id}</a>
                <p>({c.time_remaining} remaining)</p>
                <br />
              </div>
            );
          })}
          <br />
          <p>
            If you have any problems or questions, reach out to us on slack or
            email
          </p>
          <br />
        </Card>
      );
    } else if (
      currentContractor.provisional_transcriber &&
      currentContractor.queued_tqrs_count > 0
    ) {
      card = (
        <Card body>
          <h1>Your Transcript Is Being Reviewed</h1>
          <br />
          <p>
            Because you are new to QaWorld, we are reviewing your work before
            you can start on the next transcript.
          </p>
          <p>
            Once you get a passing score, you will be able to work on as many
            transcripts as you{"'"}d like without waiting for feedback.
          </p>
        </Card>
      );
    } else {
      card = (
        <Card body>
          <h1 className="large">Transcripts Available to Edit</h1>
          {queue.length === 0 && (
            <p>There are no calls at this time, please check back later.</p>
          )}
          {queue.length > 0 && (
            <div>
              <p>
                Showing {Math.min(queue.length, 20)} out of {totalCount} calls
              </p>
              <p>
                Showing{" "}
                {(
                  queue
                    .slice(0, 20)
                    .map(item => item.call_length_sec_of_human_transcribed_events)
                    .reduce((acc, value) => acc + value, 0.0) / 60.0
                ).toFixed(2)}{" "}
                minutes
              </p>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Link</th>
                    <th>Call ID</th>
                    <th>Estimated Audio for Transcription</th>
                    <th>
                      Estimated Earning &amp;
                      <br />
                      Per Minute Rate
                    </th>
                    <th>Time Allowed to Complete Call</th>
                    <th>Notes</th>
                  </tr>
                </thead>

                <tbody>
                  {queue.slice(0, 20).map((call, i) => {
                    let data = { confirm: "" };
                    if (currentContractor.transcription_count <= 5) {
                      data.confirm +=
                        'Note: Every one of your submitted transcripts is reviewed by a QA Analyst for accuracy. Only transcripts that meet our quality guidelines will be paid. For quality guidelines, click "Read the FAQ" at the top of the page.\n';
                    }
                    if (call.call_length_sec_of_human_transcribed_events > 1500) {
                      data.confirm +=
                        "Note: This call is long. Do you have enough time to work on this call right now?\n";
                    }

                    let note = "";
                    let noteStyle = { maxWidth: "200px" };
                    if ((call.call_length_sec_of_human_transcribed_events || 0) > 1800) {
                      note +=
                        "Warning! This call is long. Only take it if you can commit to finishing it within the time limit.\n";
                    }
                    const expirationTime = Math.ceil(call.time_allowed / 60.0);
                    const expirationTimeFormatted =
                      expirationTime >= 60
                        ? `${Math.floor(
                            expirationTime / 60
                          )} hours and ${expirationTime % 60} minutes`
                        : `${expirationTime} minutes`;

                    return (
                      <tr key={call.call_id}>
                        <td>
                          {claimingCall ? (
                            "Loading..."
                          ) : (
                            <a
                              href={"#"}
                              data={data}
                              id={"queue-" + i + "-" + call.call_id}
                              name="queue_item"
                              onClick={() => claimCall(call.call_id)}
                            >
                              Start Work
                            </a>
                          )}
                        </td>
                        {currentContractor.admin && (
                          <td>
                            <a href={"/calls/" + call.call_id}>
                              {call.call_id}
                            </a>
                          </td>
                        )}
                        {!currentContractor.admin && <td>{call.call_id}</td>}
                        <td>
                          {(call.call_length_sec_of_human_transcribed_events / 60.0).toFixed(1)} minutes
                        </td>
                        <td>
                          {call.earnings
                            .map(
                              earning =>
                                `$${(
                                  (earning * call.call_length_sec_of_human_transcribed_events) /
                                  60.0
                                ).toFixed(2)}`
                            )
                            .join(" / ")}
                          <br />
                          {call.earnings
                            .map(earning => `$${earning.toFixed(2)}`)
                            .join(" / ")}
                        </td>
                        <td>{expirationTimeFormatted}</td>
                        <td style={noteStyle}>
                          <p>{note}</p>
                          {!call.has_customer_side && (
                            <p>
                              You will only hear the rep side, not the customer.
                              Please read{" "}
                              <a href="https://docs.google.com/document/d/1e38d8ZLNshBcx33al9JNwAPuDph4B6AG8fOxCglibT4/edit?usp=sharing">
                                these instructions before starting.
                              </a>
                            </p>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </Card>
      );
    }

    return card;
  }
}
